var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2C16.3431 2 15 3.34315 15 5C15 5.12548 15.0077 5.24917 15.0227 5.37061L8.08261 9.17594C7.54305 8.45024 6.6967 8 5.74286 8C4.08601 8 2.74286 9.34315 2.74286 11C2.74286 12.6569 4.08601 14 5.74286 14C6.6967 14 7.54305 13.5498 8.08261 12.8241L15.0227 16.6294C15.0077 16.7508 15 16.8745 15 17C15 18.6569 16.3431 20 18 20C19.6569 20 21 18.6569 21 17C21 15.3431 19.6569 14 18 14C17.0462 14 16.1909 14.4502 15.6513 15.1759L8.71131 11.3706C8.72625 11.2492 8.73396 11.1255 8.73396 11C8.73396 10.8745 8.72625 10.7508 8.71131 10.6294L15.6513 6.82406C16.1909 7.54976 17.0462 8 18 8Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShare);
export default __webpack_public_path__ + "static/media/ic_share.d7e629ea127c275d78b7ac93b3ed6889.svg";
export { ForwardRef as ReactComponent };